import { z } from 'zod';

import { BaseFlowDecorationSchema, FlowDecorationType } from './base.js';
import { FlowDecorationColor } from './constants.js';

export const GroupNodeDataSchema = z.object({
  label: z.string().default(''),
  color: z.nativeEnum(FlowDecorationColor).default(FlowDecorationColor.Purple),
});
export type GroupNodeData = z.infer<typeof GroupNodeDataSchema>;

export const GroupNodeSchema = BaseFlowDecorationSchema.extend({
  decorationType: z.literal(FlowDecorationType.GroupNode),
  data: GroupNodeDataSchema,
  dimensions: z.object({
    width: z.number().default(240).optional(),
    height: z.number().default(240).optional(),
  }),
});
export type GroupNode = z.infer<typeof GroupNodeSchema>;
